import { compareFullOpts, Order, orderToNumber } from './compare';
/**
 * Sort a iterable into a fresh array.
 *
 * Note if not reversed we sort by default ascending.
 *
 * @param xs The iterable to sort.
 * @param makeKey The function to create the sort key. It is called for every element in `xs`
 * once. It should return a mutable array that we are allowed to change.
 * @param opts The options to use for sorting.
 * @returns A fresh array that is `xs` but sorted.
 */
export function sortBy(xs, makeKey, opts = {}) {
    // Optimization: Small arrays that are always sorted (len < 2) don't need to do any allocation.
    if (Array.isArray(xs) && xs.length < 2) {
        return xs.slice();
    }
    const { reverse: reverseGlobally = false, reversePerKey = [], caseInsensitive = false, justCmpNothingIsPerKey = [], } = opts;
    const decorated = Array.from(xs, x => [makeKey(x), x]);
    const eq = Order.EQ;
    const gt = Order.GT;
    const sortOptsPerIndex = [];
    decorated.sort(([a], [b]) => {
        let res = eq;
        let i;
        const end = Math.min(a.length, b.length);
        for (i = 0; res === eq && i < end; ++i) {
            const keyA = a[i];
            const keyB = b[i];
            let sortOpts = sortOptsPerIndex[i];
            if (sortOpts == null) {
                sortOpts = {
                    caseInsensitive,
                    justCmpNothingIs: justCmpNothingIsPerKey[i] ?? gt,
                };
                sortOptsPerIndex[i] = sortOpts;
            }
            res = compareFullOpts(keyA, keyB, sortOpts);
        }
        const reverse = reversePerKey[i - 1] ?? reverseGlobally;
        const resNumber = orderToNumber(res);
        if (reverse) {
            return resNumber * -1;
        }
        return resNumber;
    });
    return decorated.map(x => x[1]);
}
